import React from 'react';
import { AppService } from '@aperza/util';
const appConfig = AppService.appConfig();
export default class EnvironmentIndicator extends React.Component {
    render() {
        let style = {};
        if (appConfig.envLocaleBalloon === undefined) {
            style = { display: 'none' };
        }
        return (React.createElement("span", { style: style, className: `envBalloon ${appConfig.envLocaleBalloon}` }, appConfig.envLocaleBalloon));
    }
}
